module.exports = __webpack_public_path__ + "media/more_review_app/assets/images/complete_icon-3443304bf6689badb77094fd73265a9a.png";